import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import ApiPaginateSearch from "../component/ApiPaginateSearch";
import { ddmmyy, dateToTime } from "../utils/DateUtils";

import ApiEndpoints from "../network/ApiEndPoints";
import { CustomStyles } from "../component/CustomStyle";
import { android2, macintosh2, windows2, linux2 } from "../iconsImports";
import AuthContext from "../store/AuthContext";

import CachedIcon from "@mui/icons-material/Cached";
import FilterCard from "../modals/FilterCard";
let refresh;
const Leads = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  const columns = [
    {
      name: "Login At",
      selector: (row) => (
        <div>
          {ddmmyy(row.created_at)} {dateToTime(row.created_at)}
        </div>
      ),
    },

    {
      name: "Discription",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.description}
        </div>
      ),
    },
    {
      name: "Service",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.service}
        </div>
      ),
    },
    {
      name: "Mobile Number",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.mobile}
        </div>
      ),
    },
  ];

  function refreshFunc(setQuery) {
    setQuery("");
    if (refresh) refresh();
  }

  return (
    <Box>
      <Grid>
        <ApiPaginateSearch
          showSearch={false}
          isFilterAllowed={true}
          filterComponent={
            <>
              <FilterCard
                ifdescriptionFilter
                setQuery={setQuery}
                query={query}
                clearHookCb={(cb) => {
                  refresh = cb;
                }}
                refresh={refresh}
                actionButtons={
                  <>
                    <Tooltip title="refresh">
                      <IconButton
                        aria-label="refresh"
                        // color="success"
                        sx={{
                          color: "#0F52BA",
                        }}
                        onClick={() => {
                          refreshFunc(setQuery);
                        }}
                      >
                        <CachedIcon className="refresh-purple" />
                      </IconButton>
                    </Tooltip>
                  </>
                }
              />
            </>
          }
          apiEnd={ApiEndpoints.GET_ALL_LEADS}
          columns={columns}
          apiData={apiData}
          setApiData={setApiData}
          tableStyle={CustomStyles}
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
        />
      </Grid>
    </Box>
  );
};

export default Leads;
